import ComponentWrapper from './ComponentWrapper';

export default ComponentWrapper;
